export default class Currency {
  constructor() {
    this._items = [];
    this._loading = false;
  }

  get(){
    const self = this;
    return new Promise((resolve, reject) => {
      self.set();
      resolve(self);
    });
  }
  set(data){
    this._items = data.map(item=>{
      return {
        id: item.ID,
        value: item.ID,
        name: item.Name,
        label: item.IsoCode,
        national: item.IsNational,
        main: item.IsMain,
      }
    });
  }
  get loading() {
    return this._loading;
  }

  set loading(value) {
    this._loading = value;
  }

  get items() {
    return this._items;
  }
}